import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'app-withdraw-change',
	templateUrl: './withdraw-change.component.html',
	styleUrls: ['./withdraw-change.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class PixWithdrawChangeComponent implements OnInit {

	constructor() { }

	ngOnInit() {
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/pix/withdraw-change/withdraw-change.component.ts